import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Button,
  Typography,
  Modal,
  Spin,
  Row,
  Col,
  Progress,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../../reducers/loggedinuser";
import InfoIcon from "../../../../assets/quickResultInfo.svg";
import diamond from "../../../../assets/diamond.svg";
// import {
//   proceedingToTest,
//   setTraineeTestDetails,
// } from "../../../../reducers/trainee";
import {
  fetchTestTableData,
  fetchTestdata,
  proceedToTest,
} from "../../../../features/trianeeAsync";
import "../allStudentTest.css";
import { CaretUpOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import {
  givenLevels,
  givenSchools,
  givenYears,
  paper,
  terms,
} from "../../../common/constants";
import { truncateString } from "../../examPortal/TestBoardHeaderTest";
import { useWindowDimensions } from "../../examPortal/testBoard";
import { getRowsTable } from "../../utils";
import DiamondIcon from "../../../../assets/diamond.svg";
import { retriveToken, fetchAuth } from "../../../../services/AuthServices";
import Alert from "../../../common/alert";
import apis from "../../../../services/Apis";
import { useNavigate } from "react-router-dom";
import {
  SecurePost,
  SecurePostMultipart,
} from "../../../../services/axiosCall";

const SubjectTestData = ({ title }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef();
  const { allStudentTest, loading, questions } = useSelector(
    (state) => state.trainee
  );
  const { user } = useSelector((state) => state.auth);
  // console.log("AllTest", allStudentTest);
  const userid = user._id;

  const { height } = useWindowDimensions();
  const rows = getRowsTable(height);

  const componentRef = useRef(null);
  const navigate = useNavigate();

  const [mainlink, setMainlink] = useState("");
  const [showData, setShowData] = useState({});
  const [filterQueries, setFilterQueries] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalUploadOpen, setIsModalUploadOpen] = useState(false);
  const [takeTestIdData, setTakeTestIdData] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [state, setState] = useState({
    loading,
    isModalOpen: false,
    isSubmitModalOpen: false,
    isQuickResultModalOpen: false,
    isCorrectionReview: false,
    isOpenLink: false,
    qickResult: {},
    badge: [],
    ticked: 0,
  });
  //  console.log("Result",state.qickResult);

  const handleOpen = (key, obj) => {
    console.log("object", obj);

    setTakeTestIdData({ key, obj });
    setIsModalOpen(true);
  };

  const handleUploadOpen = (key, obj) => {
    // console.log("obj", obj);

    setTakeTestIdData({ key, obj });
    setIsModalUploadOpen(true);
    // console.log("Key + Obj", key, obj);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsModalUploadOpen(false);
  };

  const handleClick = (e) => {
    const btnId = e.target.dataset.id;
    setShowData({ [btnId]: true });
  };

  const handleFilterQueries = (e, name) => {
    const value = e.target.dataset.id;
    setShowData({});
    setSortedData([]);
    const existing = filterQueries.find((q) => Object.keys(q)[0] === name);
    if (existing) {
      setFilterQueries(
        filterQueries.map((q) =>
          Object.keys(q)[0] === name ? { [name]: value } : q
        )
      );
    } else {
      setFilterQueries([...filterQueries, { [name]: value }]);
    }
  };

  const filteredData = sortedData.length
    ? sortedData
    : (allStudentTest || []).filter((record) =>
        filterQueries
          .map((obj) => Object.values(obj)[0])
          .every((filter) =>
            Object.values(record).some((value) =>
              value?.toString()?.toLowerCase()?.includes(filter.toLowerCase())
            )
          )
      );

  const pageSize = rows;
  const startIndex = (currentPage - 1) * pageSize;
  const visibleData = filteredData.slice(startIndex, startIndex + pageSize);

  const handlePaginationChange = (page) => setCurrentPage(page);

  const handleSort = (columnName) => {
    const sorted = [...(allStudentTest || [])].sort((a, b) => {
      const valA = a[columnName] || "";
      const valB = b[columnName] || "";
      return valA.localeCompare(valB);
    });
    if (sortOrder === "asc") sorted.reverse();
    setSortedData(sorted);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  useEffect(() => {
    const token = retriveToken();
    if (token && token !== "undefined" && title) {
      fetchAuth(token, title).then((res) => {
        // console.log(res.data.user);
        dispatch(login(res.data.user));
      });
    } else {
      window.location = "/";
    }
  }, [title]);

  useEffect(() => {
    if (title) dispatch(fetchTestTableData({ title }));
    const baseURL = window.location.href.split("/").slice(0, 3).join("/") + "/";
    setMainlink(baseURL);
  }, [title, dispatch]);

  useEffect(() => {
    const outsideClick = (e) => {
      const clickTarget = e.target.innerText;
      const match = [
        ...givenLevels,
        ...givenYears,
        ...terms,
        ...givenSchools,
        ...paper,
      ].find((item) => item.label === clickTarget);

      if (
        clickTarget !== "Take Test" &&
        !match &&
        componentRef.current &&
        !componentRef.current.contains(e.target)
      ) {
        setShowData({});
      }
    };

    document.addEventListener("mousedown", outsideClick);
    return () => document.removeEventListener("mousedown", outsideClick);
  }, []);

  const handleConfirm = async () => {
    setIsLoader(true);
    dispatch(
      proceedToTest({
        testId: takeTestIdData?.key,
        userId: takeTestIdData.obj?.studentId,
      })
    );
    dispatch(
      fetchTestdata({
        testid: takeTestIdData?.key,
        traineeid: takeTestIdData?.obj?.studentId,
      })
    );

    setTimeout(() => {
      setIsLoader(false);
      // const params = new URLSearchParams({
      //   testid: takeTestIdData.key,
      //   traineeid: takeTestIdData.obj.studentId,
      //   isCorrect: "true",
      // });
      // window.location.href = `${window.location.origin}/#/trainee/taketest?${params}`;
      window.location.href = `${
        window.location.origin
      }/#/trainee/taketest?testid=${takeTestIdData?.key}&traineeid=${
        takeTestIdData?.obj?.studentId
      }&isCorrect=${true}`;
    }, 2000);
  };

  const handleUploadFile = async () => {
    fileInputRef.current.click();
    setIsModalUploadOpen(false);
  };

  const handleFileChange = async (e) => {
    // console.log("E", e);

    try {
      const file = e.target.files[0];
      // console.log("File", file);

      if (file.type !== "application/pdf") {
        Alert("error", "Error!", "Only PDF files are allowed.");
        return;
      }
      // console.log("File", file);
      if (!file) return;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("testid", takeTestIdData?.key);
      formData.append("studentid", takeTestIdData?.obj?.studentId);
      formData.append("userid", userid);
      // console.log("Form Data",formData);
      try {
        Alert(
          "sucess",
          "Success",
          "File uploaded Sucessfully waiting for AI Response"
        );
        const response = await SecurePostMultipart({
          url: apis.STUDENT_UPLOAD_FILE,
          data: formData,
        });
        console.log("Response", response.data);
        if (response.data.success) {
          Alert("success", "Success!", response.data.message);
          setState((prev) => ({
            ...prev,
            isQuickResultModalOpen: true,
            qickResult: response.data.data,
          }));
        } else {
          Alert("error", "Error!", response.data.message);
        }
      } catch (error) {
        Alert(
          "error",
          "Error!",
          error.response?.data?.message || error.message
        );
      }
      // setTimeout(() => {
      //   setState((prev) => ({ ...prev, isQuickResultModalOpen: true }));
      //   endTest();
      // }, 3000);
    } catch (error) {
      Alert("error", "Error!", error.message);
    }
  };

  const handleModalOpen = () => {
    setState((prev) => ({
      ...prev,
      isCorrectionReview: true,
      isQuickResultModalOpen: false,
    }));
  };
  const handleReview = (isCorrect) => {
    navigate(
      `/trainee/taketest?testid=${takeTestIdData.key}&traineeid=${takeTestIdData.obj.studentId}&isCorrect=${isCorrect}`
    );
    setState((prev) => ({
      ...prev,
      isCorrectionReview: false,
    }));
  };

  const renderFilterButton = (label, name, dataList, columnKey) => (
    <div
      data-id={name}
      className="sortButton"
      ref={componentRef}
      onClick={handleClick}
    >
      <Typography data-id={name} className="sortText">
        {filterQueries.find((item) => Object.keys(item)[0] === name)
          ? filterQueries.find((item) => Object.keys(item)[0] === name)[name]
          : name}
      </Typography>
      <div className="icons" onClick={() => handleSort(columnKey)}>
        <UpOutlined style={{ fontSize: "10px" }} />
        <DownOutlined style={{ fontSize: "10px" }} />
      </div>
      {showData?.[name] && (
        <div className="showData">
          {dataList.map((item) => (
            <Typography
              key={item.value}
              data-id={item.value}
              onClick={(e) => handleFilterQueries(e, name)}
              style={{ color: "white" }}
            >
              {item.label}
            </Typography>
          ))}
        </div>
      )}
    </div>
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "title",
      key: "title",
      render: (text) => (
        <div className="tableDataText">{truncateString(text, 25) || "N/A"}</div>
      ),
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      render: (text) => <div className="tableDataText">{text || "N/A"}</div>,
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      render: (text) => <div className="tableDataText">{text || "N/A"}</div>,
    },
    {
      title: "Term",
      dataIndex: "term",
      key: "term",
      render: (text) => <div className="tableDataText">{text || "N/A"}</div>,
    },
    {
      title: "School",
      dataIndex: "school",
      key: "school",
      render: (text) => <div className="tableDataText">{text || "N/A"}</div>,
    },
    {
      title: "Paper",
      dataIndex: "exam",
      key: "exam",
      render: (text) => <div className="tableDataText">{text || "N/A"}</div>,
    },
    {
      title: "Points",
      dataIndex: "points",
      key: "points",
      render: (text) => (
        <div className="tableDataText">
          + <img src={DiamondIcon} alt="diamond" width={16} /> {text || "N/A"}{" "}
          points
        </div>
      ),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      render: (text) => (
        <div className="tableDataText">{text ? `${text} minutes` : "N/A"}</div>
      ),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Button
            type="primary"
            style={{
              borderRadius: 35,
              backgroundColor: record.test_running ? "#3DD67A" : "#0082fb", // Green when running, blue otherwise
            }}
            onClick={() => handleOpen(record._id, record)}
          >
            {record.test_running ? "Running" : "Take Test"}
          </Button>
          <Button
            type="primary"
            style={{ borderRadius: 35, backgroundColor: "#0082fb" }}
            onClick={() => handleUploadOpen(record._id, record)}
          >
            Upload Test
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="custom_trainee_table" style={{ marginTop: 5 }}>
        <div className="sorting_Buttons">
          {renderFilterButton("Level", "Level", givenLevels, "level")}
          {renderFilterButton("Year", "Year", givenYears, "year")}
          {renderFilterButton("Term", "Term", terms, "term")}
          {renderFilterButton("School", "School", givenSchools, "school")}
          {renderFilterButton("Paper", "Paper", paper, "exam")}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: "55vh",
            height: "100%",
          }}
        >
          <Table
            className="table"
            dataSource={visibleData}
            columns={columns}
            loading={loading}
            rowClassName={(_, index) =>
              index % 2 === 0 ? "even_row" : "odd_row"
            }
            pagination={{
              pageSize,
              current: currentPage,
              total: filteredData.length,
              onChange: handlePaginationChange,
            }}
            rowKey="_id"
          />
        </div>
      </div>
 
      <Modal
        open={isModalOpen}
        footer={null}
        closable={false}
        onCancel={handleCancel}
        centered
        width={350}
        style={{ borderRadius: 25 }}
      >
        {isLoader ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <p className="modalTitle">
              {takeTestIdData?.obj?.test_running
                ? "Your test is currently running. Would you like to enter again?"
                : "Are you sure you want to start this assignment?"}
            </p>
            <div className="modalButtons">
              <Button className="modalButtonYes" onClick={handleConfirm}>
                Yes
              </Button>
              <Button className="modalButtonNo" onClick={handleCancel}>
                No
              </Button>
            </div>
          </>
        )}
      </Modal>

      <Modal
        open={isModalUploadOpen}
        footer={null}
        closable={false}
        onCancel={handleCancel}
        centered
        width={350}
        style={{ borderRadius: 25 }}
      >
        {isLoader ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <p className="modalTitle">
              Are you sure you want to upload the entire answer sheet in soft
              form?
            </p>
            <div className="modalButtons">
              <>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  accept="application/pdf"
                />
                <Button
                  className="modalButtonYes"
                  type="primary"
                  onClick={handleUploadFile}
                >
                  Yes
                </Button>
              </>
              <Button className="modalButtonNo" onClick={handleCancel}>
                No
              </Button>
            </div>
          </>
        )}
      </Modal>

      <Modal
        open={state.isQuickResultModalOpen}
        footer={null}
        closable={false}
        centered
        width={550}
        style={{ borderRadius: "25px", zIndex: 999999 }}
      >
        {Object.keys(state.qickResult).length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            {/* <Typography
              style={{ fontWeight: 600, fontSize: "18px" }}
              className="quickResultText"
            >
              {trainee.questions.find((item) => item.isLong)
                ? "Final Results Pending"
                : ""}
            </Typography> */}
            {questions.find((item) => item.isLong) ? (
              <Row>
                <Col span={24}>
                  <div className="quickResultModalParrent">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        cursor: "pointer",
                        justifyContent: "center",
                      }}
                    >
                      <Typography className="quickResultText">
                        Graded <br />
                        Component <br />
                        Marks
                      </Typography>
                      <div className="quickResultHoverInfoBox">
                        <img className="infoIcon" src={InfoIcon} alt="" />
                        <div className="quickResultInfo">
                          <Typography className="quickResultInfoText">
                            Due to the inclusion of open-ended questions in this
                            worksheet, this paper requires manual review...
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        Object.keys(state.qickResult).length !== 0
                          ? "custom-progress"
                          : "custom-progress curcularProgressEmptyFill"
                      }
                    >
                      <Progress
                        type="circle"
                        percent={state.qickResult.studentScorePercentage || 0}
                        strokeColor={
                          state.qickResult.studentScorePercentage <
                            state.qickResult.allStudentsMarksPercent &&
                          state.qickResult.studentScorePercentage > 50
                            ? "#FAFF1C"
                            : state.qickResult.studentScorePercentage >=
                                state.qickResult.allStudentsMarksPercent &&
                              state.qickResult.studentScorePercentage > 50
                            ? "#67FF0B"
                            : state.qickResult.studentScorePercentage < 50
                            ? "red"
                            : "red"
                        }
                        size={100}
                        trailColor="#d3d3d3"
                        trailWidth={10}
                        strokeStyle={{
                          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                        }}
                        format={() => (
                          <span className="progress-text-quickResult">
                            {state.qickResult.studentScore}/
                            {state.qickResult.totalMarks}
                          </span>
                        )}
                      />
                    </div>
                    <Typography
                      style={{ fontWeight: 400 }}
                      className="quickResultText"
                    >
                      {state.qickResult.studentScorePercentage}%
                      <br />
                      {state.qickResult.studentGrade}
                    </Typography>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col span={12}>
                  <div className="quickResultModalParrent">
                    <Typography className="quickResultText">
                      Your <br />
                      Marks
                    </Typography>
                    <div
                      className={
                        Object.keys(state.qickResult).length !== 0
                          ? "custom-progress"
                          : "custom-progress curcularProgressEmptyFill"
                      }
                    >
                      <Progress
                        type="circle"
                        percent={state.qickResult.studentScorePercentage || 0}
                        strokeColor={
                          state.qickResult.studentScorePercentage <
                            state.qickResult.allStudentsMarksPercent &&
                          state.qickResult.studentScorePercentage > 50
                            ? "#FAFF1C"
                            : state.qickResult.studentScorePercentage >=
                                state.qickResult.allStudentsMarksPercent &&
                              state.qickResult.studentScorePercentage > 50
                            ? "#67FF0B"
                            : state.qickResult.studentScorePercentage < 50
                            ? "red"
                            : "red"
                        }
                        size={100}
                        trailColor="#d3d3d3"
                        trailWidth={10}
                        strokeStyle={{
                          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                        }}
                        format={() => (
                          <span className="progress-text-quickResult">
                            {state.qickResult.studentScore}/
                            {state.qickResult.totalMarks}
                          </span>
                        )}
                      />
                    </div>
                    <Typography
                      style={{ fontWeight: 400 }}
                      className="quickResultText"
                    >
                      {Math.round(state.qickResult.studentScorePercentage)}%
                      <br />
                      {state.qickResult.studentGrade}
                    </Typography>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="quickResultModalParrent">
                    <Typography className="quickResultText">
                      Average <br /> Marks
                    </Typography>
                    <div
                      className={
                        Object.keys(state.qickResult).length !== 0
                          ? "custom-progress"
                          : "custom-progress curcularProgressEmptyFill"
                      }
                    >
                      <Progress
                        type="circle"
                        percent={state.qickResult.allStudentsMarksPercent || 0}
                        strokeColor="#fff"
                        size={100}
                        trailColor="#d3d3d3"
                        trailWidth={10}
                        strokeStyle={{
                          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                        }}
                        format={() => (
                          <span className="progress-text-quickResult">
                            {state.qickResult.allStudentsMarksAverage}/
                            {state.qickResult.totalMarks}
                          </span>
                        )}
                      />
                    </div>
                    <Typography
                      style={{ fontWeight: 400 }}
                      className="quickResultText"
                    >
                      {state.qickResult.allStudentsMarksPercent}%
                      <br />
                      {state.qickResult.totalGrade}
                    </Typography>
                  </div>
                </Col>
              </Row>
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              <Typography
                style={{ fontWeight: 400 }}
                className="quickResultText"
              >
                Points earned:
              </Typography>
              {state.qickResult.monthlyCapReached ? (
                <Typography
                  style={{ fontWeight: 400 }}
                  className="quickResultText"
                >
                  (Monthly Point Cap Reached)
                </Typography>
              ) : (
                <div>
                  <Typography
                    style={{ fontWeight: 400 }}
                    className="quickResultText"
                  >
                    + <img width="22px" src={diamond} alt="" />{" "}
                    {state.qickResult.earnPoint} points
                    <sub style={{ fontSize: "14px" }}>(completion)</sub>
                  </Typography>
                  <Typography
                    style={{ fontWeight: 400 }}
                    className="quickResultText"
                  >
                    + <img width="22px" src={diamond} alt="" />{" "}
                    {state.qickResult.performancePoint} points{" "}
                    <sub style={{ fontSize: "14px" }}>(performance bonus)</sub>
                  </Typography>
                </div>
              )}
              <div>
                <Typography
                  style={{ fontWeight: 700, color: "#888888" }}
                  className="quickResultText"
                >
                  <img width="22px" src={diamond} alt="" />{" "}
                  {state.qickResult.totalPoints} points
                </Typography>
                <Typography
                  style={{
                    fontWeight: 400,
                    color: "#BABABA",
                    fontSize: "18px",
                  }}
                  className="quickResultText"
                >
                  points Accumulated
                </Typography>
              </div>
            </div>

            <Row justify="center">
              <Col>
                <div className="modalButtons">
                  <Button className="modalButtonNo" onClick={handleModalOpen}>
                    Review Test
                  </Button>
                  <Button
                    className="modalButtonNo"
                    onClick={() => {
                      // handleTestComplete();
                      // dispatch(switchQuestion(0));
                      navigate("/user/livetest");
                    }}
                  >
                    Return to Take Test page
                  </Button>
                  <Button
                    className="modalButtonNo"
                    onClick={() => {
                      // handleTestComplete();
                      // dispatch(switchQuestion(0));
                      navigate("/user/testHistory");
                    }}
                  >
                    Return to Test History
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Modal>
      <Modal
        open={state.isCorrectionReview}
        footer={null}
        onCancel={handleCancel}
        centered
        width={350}
        style={{ borderRadius: "25px" }}
        closable={false}
      >
        <div style={{ width: "100%" }}>
          <Typography.Text className="modalTitle">
            Which review option do you wish to choose:
          </Typography.Text>
        </div>
        <div className="modalButtons">
          <Button className="modalButtonNo" onClick={() => handleReview(true)}>
            Full Review
          </Button>
          <Button className="modalButtonNo" onClick={() => handleReview(false)}>
            Correction Review
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default SubjectTestData;
